if (!customElements.get('gallery-tooltip')) {
  class GalleryTooltip extends HTMLElement {
    constructor() {
      super();
      this.setup();
      this.updateIsMobile();
      this.enableResizeListener();
    }

    setup() {
      this.closeButton = this.querySelector('.icon-close');
      this.tooltipButton = this.querySelector('.tooltip-button');
      this.componentWrapper = this.parentNode;
      this.hotspotImageWrapper = this.closest('.hotspot-image-wrapper');
      this.sectionWrapper = this.closest('.hotspot-gallery');
      
      this.mobileTooltipContent = this.querySelector('.tooltip-content-mobile');
      this.desktopTooltipContent = this.querySelector('.tooltip-content-desktop');
      this.allTooltips = this.componentWrapper.querySelectorAll('.tooltip-button');

      this.applyMobileStyles();
      this.bindListeners();
    }

    bindListeners() {
      this.tooltipButton.addEventListener("click", this.tooltipToggle.bind(this));
      document.addEventListener("click", this.hotSpots.bind(this));
      this.closeButton.addEventListener("click", this.close.bind(this));
    }

    enableResizeListener() {
      window.addEventListener('resize', () => {
        this.updateIsMobile();
        this.applyMobileStyles();
        this.closeAllTooltips();
      });
    }

    updateIsMobile() {
      this.isMobile = window.matchMedia('(max-width: 990px)').matches;
    }

    applyMobileStyles() {
      if (this.isMobile) {
        this.mobileTooltipContent.style.height = '0';
        this.mobileTooltipContent.style.overflow = 'hidden';
        this.mobileTooltipContent.style.opacity = '0';
        this.mobileTooltipContent.style.visibility = 'hidden';
      }
    }

    tooltipToggle() {
      if (this.tooltipButton.getAttribute("aria-expanded") === "false") {
        this.open(this.tooltipButton);
      } else {
        this.close(this.tooltipButton);
      }
    }

    hotSpots(event) {
      if (!event.target.closest('.tooltip-button')) {
        this.closeAllTooltips();
      }
    }

    slideDown(el, onComplete) {
      el.style.padding = '1rem';
      const contentHeight = el.scrollHeight;
      const offsetHeight = el.offsetHeight;
      const totalHeight = contentHeight + offsetHeight;
      
      el.style.transition = 'height 0.2s ease-out, opacity 0.15s ease-out';
      this.sectionWrapper.style.transition = 'padding 0.2s ease-in';
      el.querySelector('img').style.transition = 'height 0.2s ease-out, opacity 0.15s ease-out';
      el.style.height = `${totalHeight}px`;
      el.style.opacity = '1';
      el.style.visibility = 'visible';

      if (this.isMobile) {
        this.sectionWrapper.style.paddingBottom = `${totalHeight}px`;
      }

      el.addEventListener('transitionend', function handler(event) {
        if (event.propertyName !== 'height') return;

        el.style.height = 'auto';
        el.querySelector('img').style.height = 'auto';
        el.removeEventListener('transitionend', handler);
        onComplete?.();
      });
    }

    ensureMobileTooltipVisible(triggerButton) {
      const panel = this.mobileTooltipContent;
      if (!panel || !triggerButton) return;

      const viewportPadding = 16;
      const buttonRect = triggerButton.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();
      const isClipped =
        buttonRect.top < viewportPadding ||
        panelRect.bottom > window.innerHeight - viewportPadding;

      if (!isClipped) return;

      const scrollTarget = panelRect.height > 0 ? panel : triggerButton;
      scrollTarget.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    slideUp(el) {
      const contentHeight = el.scrollHeight;
      const offsetHeight = el.offsetHeight;
      const totalHeight = contentHeight + offsetHeight;

      el.style.transition = 'height 0.2s ease-in, opacity 0.15s ease-in';
      this.sectionWrapper.style.transition = 'padding 0.2s ease-in';
      el.style.height = `${totalHeight}px`;
      el.style.opacity = '0';

      if (this.isMobile) {
        this.sectionWrapper.style.paddingBottom = '0';
      }

      requestAnimationFrame(() => {
        el.style.height = '0';
        el.style.visibility = 'hidden';
        el.querySelector('img').style.height = '0';
        el.style.padding = '0';
      });
    }

    open(el) {
      this.closeAllTooltips();
      el.setAttribute("aria-expanded", "true");
      el.classList.add('tooltip-active');

      if (this.isMobile) {
        this.slideDown(this.mobileTooltipContent, () => {
          this.ensureMobileTooltipVisible(el);
        });
      }
    }

    close(el) {
      el.setAttribute("aria-expanded", "false");
      el.classList.remove('tooltip-active');

      if (this.isMobile) {
        this.slideUp(this.mobileTooltipContent);
      }
    }

    closeAllTooltips() {
      this.allTooltips.forEach((tooltip) => {
        if (tooltip.getAttribute("aria-expanded") === "true") {
          tooltip.setAttribute("aria-expanded", "false");
          tooltip.classList.remove('tooltip-active');

          if (this.isMobile) {
            const mobileContent = tooltip.closest('.gallery-tooltip').querySelector('.tooltip-content-mobile');
            this.slideUp(mobileContent);
          }
        }
      });
    }
  }

  customElements.define('gallery-tooltip', GalleryTooltip);
}
